import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import MenuItemRow from '#client/components/MenuItemRow';
import useAccountDetails from '#client/hooks/useAccountDetails';

import { DividerStyled } from '../BankingTitle.styles';

export default function AccountDetails() {
  const { accountNumberText, copyAddress, nameText, renderAddress, routingNumberText } =
    useAccountDetails();

  const trackCopyAccountNumberPressed = useButtonPressedCallback({
    elementName: 'copy_account_number',
    elementText: 'ACCOUNT NUMBER',
    appPageName: 'active_banking_dashboard'
  });

  const trackCopyRoutingNumberPressed = useButtonPressedCallback({
    elementName: 'copy_routing_number',
    elementText: 'ROUTING NUMBER',
    appPageName: 'active_banking_dashboard'
  });

  return [
    <MenuItemRow
      /**
       * Tracking Details: Tracking added to Account Details button
       * Question: How many users click the account number copy buttons?
       */
      callback={trackCopyAccountNumberPressed}
      copyText={accountNumberText}
      key="account-number"
      menuKey="account-number"
      texts={[accountNumberText]}
      title="ACCOUNT NUMBER"
    />,
    <MenuItemRow
      /**
       * Tracking Details: Tracking added to Account Details button
       * Question: How many users click the routing number copy buttons?
       */
      callback={trackCopyRoutingNumberPressed}
      copyText={routingNumberText}
      key="routing-number"
      menuKey="routing-number"
      texts={[routingNumberText]}
      title="ROUTING NUMBER"
    />,
    <DividerStyled key="menu-divider" />,
    <Stack
      key="wire-transfer"
      paddingLeft={{ xs: '32px', md: '24px' }}
      paddingRight={{ xs: '32px', md: '24px' }}
    >
      <Text
        color="primary"
        size="xs"
        weight="medium"
      >
        Receive Wire Transfers
      </Text>
    </Stack>,
    <MenuItemRow
      copyText={nameText}
      key="account-name"
      menuKey="account-name"
      texts={[nameText]}
      title="ACCOUNT NAME"
    />,
    <MenuItemRow
      copyText="Thread Bank"
      key="bank-name"
      menuKey="bank-name"
      texts={['Thread Bank']}
      title="BANK NAME"
    />,
    <MenuItemRow
      copyText={copyAddress}
      key="bank-address"
      menuKey="bank-address"
      texts={renderAddress}
      title="ADDRESS"
    />
  ];
}
